import { Component, OnInit, ViewChild, Input, ViewChildren, Output, QueryList, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from 'src/app/views/shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { IProductMultipleSelection, ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import gql from 'graphql-tag';
import { MDBDatePickerComponent, ToastService, IMyOptions, LocaleService } from 'ng-uikit-pro-standard';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { TipoDescuentoService } from 'src/app/services/tipo-descuento.service';
import * as _ from 'lodash';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ProductoService } from 'src/app/services/producto.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalVerErroresComponent } from 'src/app/views/shared/modal-ver-errores/modal-ver-errores.component';
import { DocumentoService } from 'src/app/services/documento.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { AuditoriaInput } from 'src/app/views/configuracion-sistema/auditoria/lista-auditoria/lista-auditoria.component';

type MODE = 'ADD' | 'EDIT' | 'VIEW';

@Component({
  selector: 'app-modal-addedit-descuentos',
  templateUrl: './modal-addedit-descuentos.component.html',
  styleUrls: ['./modal-addedit-descuentos.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ModalAddeditDescuentosComponent implements OnInit {
  @Input() permiteUnidadNegocio: any = [];

  // Inputs
  optionsTipoDescuentoAll: any = [];

  // Outputs
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('agregarDescuento', { static: true }) modalAgregarDescuento: ModalDirective;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent;
  @ViewChildren(ModalSeleccionarProductoComponent) modalSeleccionarProducto: QueryList<ModalSeleccionarProductoComponent>;
  @ViewChild('datePickerInicio', { static: true }) datePickerInicio: MDBDatePickerComponent;
  @ViewChild('datePickerFinal', { static: true }) datePickerFinal: MDBDatePickerComponent;
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Calendario Options
  myDatePickerOptions: IMyOptions = {};

  locales = {
    es: {
      dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'mie', th: 'Jue', fr: 'Vie', sa: 'Sab' },
      dayLabelsFull: { su: 'Domingo', mo: 'Lunes', tu: 'Martes', we: 'Miércoles', th: 'Jueves', fr: 'Viernes', sa: 'Sábado' },
      monthLabels: {
        1: 'Ene',
        2: 'Feb',
        3: 'Mar',
        4: 'Abr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Ago',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dic',
      },
      monthLabelsFull: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      },
      dateFormat: 'dd/mmmm/yyyy',
      todayBtnTxt: 'Hoy',
      clearBtnTxt: 'Limpiar',
      closeBtnTxt: 'Cerrar',
      firstDayOfWeek: 'mo',
      sunHighlight: true,
      closeAfterSelect: true,
    },
  };

  // Form
  formHeader: FormGroup;
  formDetails: FormGroup;

  // Constants
  readonly TIPO_CLIENTE: String = `_CLIENTE_`;
  readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`;

  readonly MODAL_SEL_PROD_DESCUENTO = 'MODAL_SEL_PROD_DESCUENTO';

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  private rutUsuario: Number;

  private loading: boolean = false;
  private loaded: boolean = false;
  defaultUnidadNegocio: number = null;
  codigoDescuento: number = -1;
  listaDescuentos: any = [];
  listaDescuentosPage: any = [];
  paginationContext: PaginationContext = new PaginationContext();
  lastIndex: number = 0;
  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null;
  clientesGuardadosAnterior: Array<any> = null;

  clientesSeleccionadosFormatted: String = null;
  tiposClientesSeleccionados: any = null;
  tiposClientesSeleccionadosFormatted: String = null;
  productosMultiplesSeleccionados: any[] = null;
  mode: MODE;
  inputLinea: number = 9999;
  // Utils
  private log: any;
  DescProduct: any;
  EditarDesc: number = 0;
  DescProductSelect: number = 0;
  EditoDesc: number = 0;
  currentTabs: string;
  auditoria: AuditoriaInput;

  // getters
  get modalDescuento() {
    return this.modalSeleccionarProducto.filter((mod) => mod.origen === this.MODAL_SEL_PROD_DESCUENTO)[0];
  }

  btnGuardarDisabled: boolean = false;

  optionsTipoDescuento: Array<any> = [
    { value: '1', label: 'Monto' },
    { value: '2', label: 'Porcentaje' },
  ];

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private tipoDescuentoService: TipoDescuentoService,
    private productoService: ProductoService,
    public validadores: ValidadoresService,
    private formValidatorsService: FormValidatorsService //private localeService: LocaleService
  ) {
    this.log = this.clog.log('MODAL-DCTOS-ESPECIALES');
    //this.localeService.setLocaleOptions(this.locales);
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();
    this.rutUsuario = this.accesolocalstorage.getRutUsuario();
    this.paginationContext.RecordsByPage = 10;
    this.loadTipoDescuento();
    this.createForms();
    this.formChangesSubscriptions();
  }

  trackByDetalleProductoCodigo(index: number, item: any) {
    return item && item.producto_codigo != null ? item.producto_codigo : (item && item.codigo != null ? item.codigo : index);
  }

  verDetalle() {
    this.currentTabs = "detalle";
  }
  verAuditoria() {
    this.auditoria = {
      codigoEntidad: this.codigoDescuento,
      entidad: 'DESCUENTO ESPECIAL'
    };
    this.currentTabs = "auditoria";
  }

  /********* SHOW/HIDE *********/
  show(mode: MODE) {
    this.mode = mode;
    if (mode === 'ADD') {
      this.codigoDescuento = -1;
      this.currentTabs = 'detalle';
      this.reset();
      this.formDetails.get('tipoDescuento').setValue('2');
    } else {
      this.EditoDesc = 1;
      // this.disabledContent = true
      // this.disabledContent = false // LO DEJO ASÍ YA QUE CREO QUE SE ITERARÁ SOBRE ESTO.
    }
    this.modalAgregarDescuento.show();
  }

  hide() {
    this.listaDescuentosPage = [];
    this.EditarDesc = 0;
    this.EditoDesc = 0;
    this.btnGuardarDisabled = false;
    this.modalAgregarDescuento.hide();
    this.clientesSeleccionados = [];
    this.formHeader.get('descripcion').setValue('');
    this.formHeader.get('buscarPor').setValue(this.TIPO_CLIENTE);
    this.formHeader.get('clienteOrTipos').setValue(null);
    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('fechaInicio').setValue('');
    this.formHeader.get('fechaFin').setValue('');
    this.formDetails.get('montoOrPorcentaje').setValue('');
    this.productosMultiplesSeleccionados = null;
  }

  reset() {
    this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside();
    if (this.mode === 'EDIT' || this.mode === 'VIEW') {
      this.datePickerInicio.clearDate();
      this.datePickerFinal.clearDate();
      this.lastIndex = 0;
    }

    this.resetFormHeader();
    this.resetFormDetails();
    this.resetListaDescuentos();
  }

  resetFormHeader() {
    this.formHeader.reset();
    this.formHeader.markAsPristine();
    this.formHeader.markAsUntouched();

    this.formHeader.get('descripcion').setValue('');
    this.formHeader.get('buscarPor').setValue(this.TIPO_CLIENTE);
    this.formHeader.get('clienteOrTipos').setValue(null);
    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('fechaInicio').setValue('');
    this.formHeader.get('fechaFin').setValue('');
    this.formDetails.get('montoOrPorcentaje').setValue('');

    this.clientesSeleccionados = [];
    this.clientesSeleccionadosFormatted = null;
    this.tiposClientesSeleccionados = null;
    this.tiposClientesSeleccionadosFormatted = null;
    this.productosMultiplesSeleccionados = null;
  }

  resetFormDetails() {
    this.formDetails.reset();
    this.formDetails.markAsPristine();
    this.formDetails.markAsUntouched();

    this.formDetails.get('codigoProducto').setValue('');
    this.formDetails.get('tipoDescuento').setValue(null);
    this.formDetails.get('montoOrPorcentaje').setValue('');

    this.productosMultiplesSeleccionados = null;
  }

  resetListaDescuentos() {
    this.paginationContext.CurrentPage = 1;
    this.listaDescuentos = [];
    this.listaDescuentosPage = [];
  }
  /********* SHOW/HIDE *********/

  /********* FORMS *********/
  loadTipoDescuento() {
    this.optionsTipoDescuentoAll = this.tipoDescuentoService.GetTiposDescuento();
  }

  createForms() {
    this.formHeader = this.fb.group({
      descripcion: ['', [Validators.required]],
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      clienteOrTipos: [null, [Validators.required]],
      activo: [true],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
    });
    this.formDetails = this.fb.group({
      codigoProducto: ['', [Validators.required, Validators.min(1)]],
      tipoDescuento: ['2', [Validators.required]],
      montoOrPorcentaje: [null, [Validators.required, Validators.min(1), this.descuentoValidator()]], // TODO: Custom validator para toogle monto/porcentaje
    });
  }

  descuentoValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value !== null && control.value !== undefined) {
        const valueWithDot = control.value.replace(',', '.');
        const descuento = parseFloat(valueWithDot);
        if (control.value != '' && isNaN(descuento)) {
          return { descuentoInvalido: { value: control.value } };
        } else {
          const descuentoStr = descuento.toString();
          const puntoDecimalPos = descuentoStr.indexOf('.');
          if (puntoDecimalPos !== -1 && descuentoStr.length - puntoDecimalPos > 3) {
            return { descuentoInvalido: { value: control.value } };
          }
        }
      }
      return null; // No hay error de validación
    };
  }

  formChangesSubscriptions() {
    this.formDetails.get('tipoDescuento').setValue('2');
    this.formHeader.get('buscarPor').valueChanges.subscribe((buscarPor) => {
      this.limpiarBuscarPorCliente();
      this.limpiarBuscarPorTiposClientes();
      this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside();

      if (buscarPor === this.TIPO_CLIENTE) {
        this.optionsTipoDescuento = _.cloneDeep(this.optionsTipoDescuentoAll);
        this.formDetails.get('tipoDescuento').setValue('2');
      }
      if (buscarPor === this.TIPO_TIPO_CLIENTE) {
        this.optionsTipoDescuento = _.cloneDeep(this.optionsTipoDescuentoAll).filter((opt) => opt.value === '2');
        this.formDetails.get('tipoDescuento').setValue('2');
      }
    });

    // código de producto
    // this.formDetails.get("codigoProducto").valueChanges
    //   .pipe(filter(Boolean), debounceTime(2500))
    //   .subscribe((codigo: string) => {
    //     this.log('codigoProducto valueChanges', codigo)
    //     this.modalDescuento.searchBySKU(codigo)
    //   })

    this.formDetails
      .get('codigoProducto')
      .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((codProductRaw: string) => {
        const codProduct = ((codProductRaw as any) || '').toString().trim();

        // Estandarizar comportamiento con "Add Nota Venta":
        // - buscar por SKU con debounce
        // - permitir borrar el input (limpia selección y cache del modal)
        if (!codProduct) {
          this.productosMultiplesSeleccionados = null;
          if (this.modalDescuento) {
            this.modalDescuento.clearLast();
          }
          return;
        }

        this.modalDescuento.searchBySKU(codProduct);
      });
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    if (this.mode == 'VIEW') {
      this.clientesSeleccionados = null;
      this.clientesSeleccionadosFormatted = null;
    }
  }

  limpiarBuscarPorTiposClientes() {
    if (this.mode == 'VIEW') {
      this.tiposClientesSeleccionados = null;
      this.tiposClientesSeleccionadosFormatted = null;
    }
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null;
    this.tiposClientesSeleccionados = null;
    this.DescProduct = null;
  }

  abrirModalSeleccion() {
    this.EditarDesc = 1;

    if (this.formHeader.get('buscarPor').value === this.TIPO_CLIENTE) this.abrirModalSeleccionarCliente();
    else if (this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE) this.abrirModalSeleccionarClientesTipos();
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show({ paginateLocally: true });
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected({
      paginateLocally: true,
      allowUncheckSelected: this.mode === 'EDIT' || this.mode === 'ADD',
    });
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected();
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados);
  }

  abrirModalSeleccionarProducto() {
    this.modalDescuento.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio,
    });
  }

  abrirModalSeleccionarProductosSeleccionados() {
    this.modalDescuento.showSelected(this.productosMultiplesSeleccionados);
  }

  // remote query for modal selección Producto
  getProductsByUnidadNegocio({ inputParams, callback }) {

    if (this.permiteUnidadNegocio) {
      const unidadNegocio = inputParams.unidad_negocio_codigo ? inputParams.unidad_negocio_codigo : this.defaultUnidadNegocio;

      // ** Si no hay unidad seleccionada aún, se hace fallback a la búsqueda estándar (sin UN),
      // **para que se pueda autocompletar/seleccionar sin spamear toasts.
      if (!unidadNegocio) {
        this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
          if (mensajes && mensajes.length > 0) {
            this.messageRendererService.showErrors(mensajes);
            return;
          }

          if (!respuesta) {
            callback(new QueryResult(null, 0, 0, 0));
            return;
          }
          const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
          callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
        return;
      }

      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: unidadNegocio,
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina,
      };

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams));

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    } else {
      this.log('inputParams', JSON.stringify(inputParams));
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    }
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  //   this.formHeader.get("clienteOrTipos").setValue(this.clienteSeleccionado)
  // }
  async onClienteSeleccionadoMultiple({ data, origen }) {
    console.log('muestrame los clientes guardados en el load ', this.clientesGuardadosAnterior);

    // let clSelect: any = [];
    // if (this.clientesGuardadosAnterior != null) {
    //   clSelect = this.clientesGuardadosAnterior.filter((cl) => cl.checked == true);
    // }
    // console.log(clSelect);
    this.limpiarDataSeleccionada();
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data;
    this.clientesSeleccionadosFormatted = _.uniq(this.clientesSeleccionados.map((p) => p.nombre)).join(', ');
    this.formHeader.get('clienteOrTipos').setValue(this.clientesSeleccionadosFormatted);

    // if (clSelect.length > 0) {
    //   this.clientesSeleccionados = clSelect;
    // }
    const cliente = data.map((x) => {
      let rut_cliente = '';
      let direccion_codigo = 0;
      if (x.cliente_proveedor_rut) {
        rut_cliente = x.cliente_proveedor_rut;
        direccion_codigo = x.direccion_codigo;
      } else {
        rut_cliente = x.rut;
        direccion_codigo = x.codigo_direccion;
      }

      const params = {
        rut_cliente,
        codigo_direccion: direccion_codigo,
      };

      return params;
    });

    console.log('rut del cliente ', cliente);

    const cliente_select = {
      clientes_seleccionados: cliente,
      lista_producto: this.listaDescuentosPage.map((x) => x.producto_codigo),
    };

    console.log(cliente_select);
    // Validar que el cliente no este en un descuento activo
    if (this.mode == 'ADD' || this.mode == 'EDIT') {
      if (this.EditarDesc == 1) {
        // this.DescProduct = await this.validarExisteClienteEnDescuento(cliente_select);
        console.log('Función externa completada. Continuando con la función principal');

        // this.clientesSeleccionados =
        for (let i = 0; i < this.listaDescuentosPage.length; i++) {
          var producto = this.listaDescuentosPage[i];
          producto.codigo = this.listaDescuentosPage[i].producto_codigo;
          this.DescProduct = await this.validarExisteClienteEnDescuento(cliente_select);
          console.log('Función externa completada. Continuando con la función principal');

          if (this.DescProduct.listaClientes == true) {
            console.log('this.DescProduct', this.DescProduct);
            const clientSelect = this.modalSeleccionarCliente.clearClientes(this.DescProduct.registros);
            // this.clientesSeleccionados = this.clientesSeleccionados.filter(cl=> clientSelect.includes(cl.cliente_proveedor_rut))

            console.log('clientSelect', clientSelect);

            //  let data = this.clientesSeleccionados.forEach((cl) => {
            //     clientSelect.forEach((item) => {
            //       if (item.rut != cl.rut) {
            //         item.cliente_encontrado = true;
            //       }
            //     });
            //   });

            const idSet = new Set(clientSelect.map((item) => item.rut));

            // Filtrar los objetos en list1 que no tienen el mismo id que los objetos en list2.
            const result = this.clientesSeleccionados.filter((item) => !idSet.has(item.rut));

            this.clientesSeleccionados = clientSelect;
            console.log('this.clientesSeleccionado3', result);

            this.DescProduct.registros.forEach((clientes) => {
              const rutClienteFormateado = this.validadores._enmascaraRut(clientes.rut_cliente.toString());
              this.toastrService.warning(`Producto sku ${producto.sku} del cliente ${rutClienteFormateado} se encuentra en un descuento activo`);
            });
            return;
          }
        }
      }
    } else {
      this.EditarDesc = 0;
    }
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada();
    this.tiposClientesSeleccionados = data;
    this.formHeader.get('clienteOrTipos').setValue(this.tiposClientesSeleccionados);
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map((p) => p.descripcion).join(', ');
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productosMultiplesSeleccionados = [];
    this.productosMultiplesSeleccionados.push(_productoSeleccionado);
    this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku);
    // this.setCodigoProductoValidators('ADD')
  }

  onProductoNoEncontrado() {
    this.productosMultiplesSeleccionados = null;
  }

  onMultiplesProductosSeleccionados(data: IProductMultipleSelection) {
    this.log(data);
    this.productosMultiplesSeleccionados = data.data;
    if (data.data.length === 1) {
      this.formDetails.get('codigoProducto').setValue(data.data[0].sku);
      this.setCodigoProductoValidators('ADD');
    } else {
      this.formDetails.get('codigoProducto').setValue('');
      this.setCodigoProductoValidators('REMOVE');
    }
  }
  /********* MODALS *********/

  /********* OPERATIONS *********/
  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.renderItemDescuento();
  }

  setCodigoProductoValidators(type: 'ADD' | 'REMOVE') {
    if (type === 'ADD') {
      this.formDetails.get('codigoProducto').setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.formDetails.get('codigoProducto').setValidators([]);
    }
    this.formDetails.get('codigoProducto').updateValueAndValidity();
  }

  async agregarItemDescuento() {
    if (this.productosMultiplesSeleccionados !== null && this.productosMultiplesSeleccionados.length > 1) {
      this.setCodigoProductoValidators('REMOVE');
    } else {
      this.setCodigoProductoValidators('ADD');
    }

    this.formValidatorsService.validateAllFormFields(this.formDetails);

    const fechaInicio = this.formHeader.get('fechaInicio').value;
    const fechaFin = this.formHeader.get('fechaFin').value;

    if (fechaInicio == null || fechaInicio === '') {
      this.toastrService.warning('Ingrese Fecha de inicio');
      return;
    }

    if (fechaFin == null || fechaFin === '') {
      this.toastrService.warning('Ingrese Fecha de termino');
      return;
    }

    if (this.clientesSeleccionados === null && this.tiposClientesSeleccionados == null) {
      this.toastrService.warning('Ingrese Cliente para seleccionar un producto');
      return;
    }

    if (this.productosMultiplesSeleccionados !== null && this.productosMultiplesSeleccionados.length === 0) {
      this.toastrService.warning('Ingrese producto(s)');
      return;
    }

    if (this.optionsTipoDescuento.length === 1) {
      this.formDetails.get('tipoDescuento').setValue(this.optionsTipoDescuento[0].value);
    }

    if (!this.formDetails.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return;
    }

    if (this.productosMultiplesSeleccionados !== null) {
      // Validar existencia en otro descuento con cliente, fecha vigente y activo
      if (this.clientesSeleccionados != null) {
        var DescProduct: any;
        // for (let i = 0; i < this.productosMultiplesSeleccionados.length; i++) {
        // const producto = this.productosMultiplesSeleccionados[i];
        DescProduct = await this.validarExisteProductoEnDescuento(this.productosMultiplesSeleccionados);
        console.log('Función externa completada. Continuando con la función principal');
        if (DescProduct.listaClientes == true) {
          DescProduct.registros.forEach((clientes) => {
            const rutClienteFormateado = this.validadores._enmascaraRut(clientes.rut_cliente.toString());
            const findError = DescProduct.mensajes.some((x) => x.tipo === 'ERROR');
            if (findError) {
              //Mensaje modal de error
              this.modalVerErrores.loadAndShow(DescProduct.mensajes);
              // this.toastrService.warning(`Producto sku ${producto.sku} del cliente ${rutClienteFormateado} se encuentra en un descuento activo`);
              return;
            }
          });
          return;
        }
        // }
      }

      const productoUnico: boolean = this.productosMultiplesSeleccionados.length === 1;
      let productosAgregadosCount: number = 0;
      // this.productosMultiplesSeleccionados.forEach(producto => {
      for (let i = 0; i < this.productosMultiplesSeleccionados.length; i++) {
        const producto = this.productosMultiplesSeleccionados[i];

        // Validar existencia en lista
        if (!this.validateExistenceInList(producto)) {
          this.toastrService.warning(`Producto sku ${producto.sku} ya se encuentra en lista`);
          if (productoUnico) return;
          else continue;
        }

        // Validar unidad de negocio
        if (this.permiteUnidadNegocio)
          if (!this.validateUnidadNegocioNewProduct(producto)) {
            this.toastrService.warning(`Producto sku ${producto.sku} debe tener la misma unidad de negocio`);
            return;
          }

        // nuevo item
        const newDcto: any = this.createPayloadProducto(producto);

        this.listaDescuentos.push(newDcto);
        this.lastIndex++;
        productosAgregadosCount++;
        this.fixAndDisableUnidadNegocio(producto);
      }
      if (productoUnico) this.toastrService.success(`Producto agregado`);
      else if (productosAgregadosCount > 0) this.toastrService.success(`${productosAgregadosCount} productos agregados`);
    }
    this.renderItemDescuento();
    this.resetFormDetails();
    this.formDetails.reset();
    this.formDetails.get('tipoDescuento').setValue('2');
    this.productosMultiplesSeleccionados = null;
    this.EditoDesc = 1;
    this.log(this.listaDescuentos);
  }

  //*INICIO EDICION DE PORCENTAJE

  //habilitar edicion del input
  EditarProducto(dcto, index) {
    this.DescProductSelect = dcto.producto_codigo;
    this.inputLinea = index;
    this.EditoDesc = 0;
  }

  ProcesoEditarPedidoCompletado() {
    //* SE REALIZA BUSQUEDA DEL PRODUCTO SELECCIONADO PARA MODIFICAR SU PORCENTAJE
    this.listaDescuentosPage.map((item) => {
      if (item.producto_codigo === this.DescProductSelect) {
        //* SI PORCENTAJE CONTIENE "," SE REEMPLAZA POR "."

        if (typeof item.porcentaje === 'string') {
          if (item.porcentaje.includes(',')) {
            item.porcentaje = item.porcentaje.replace(',', '.');
          }
        }
      }
    });
    this.EditoDesc = 1;
    this.inputLinea = 9999;
  }

  //*FIN EDICION DE PORCENTAJE

  async validarExisteProductoEnDescuento(producto) {
    const a = await new Promise((resolve) => {
      setTimeout(() => {
        // const rutClientes = this.clientesSeleccionados.map((x) => x.rut);
        const rutClientes = this.clientesSeleccionados.map((x) => {
          const params = {
            rut_cliente: x.rut,
            codigo_direccion: x.codigo_direccion,
          };

          return params;
        });

        const entidad = producto.map((x) => {
          const params = {
            descuento_codigo: this.codigoDescuento,
            producto_codigo: x.codigo,
            rut_empresa: x.empresa_rut,
            descripcion: x.descripcion,
            // tipoDescuento: this.formDetails.get('tipoDescuento').value,
            // tipoDescuentoGlosa: this.optionsTipoDescuento.filter((opt) => Number(opt.value) === Number(this.formDetails.get('tipoDescuento').value))[0].label,
            // monto: this.formDetails.get('tipoDescuento').value === '1' ? Number(this.formDetails.get('montoOrPorcentaje').value) : 0,
            // porcentaje: this.formDetails.get('tipoDescuento').value === '2' ? Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.')) : 0,
            // index: this.listaDescuentos.length + 1,
            fecha_inicio: this.formHeader.get('fechaInicio').value,
            fecha_termino: this.formHeader.get('fechaFin').value,
          };
          return params;
        });

        const inputParams = {
          // entidad: {
          //   // descuento_codigo: this.codigoDescuento,
          //   // producto_codigo: producto.codigo,
          //   // rut_empresa: producto.empresa_rut,
          //   // descripcion: producto.descripcion,
          //   // // tipoDescuento: this.formDetails.get('tipoDescuento').value,
          //   // // tipoDescuentoGlosa: this.optionsTipoDescuento.filter((opt) => Number(opt.value) === Number(this.formDetails.get('tipoDescuento').value))[0].label,
          //   // // monto: this.formDetails.get('tipoDescuento').value === '1' ? Number(this.formDetails.get('montoOrPorcentaje').value) : 0,
          //   // // porcentaje: this.formDetails.get('tipoDescuento').value === '2' ? Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.')) : 0,
          //   // // index: this.listaDescuentos.length + 1,
          //   // fecha_inicio: this.formHeader.get('fechaInicio').value,
          //   // fecha_termino: this.formHeader.get('fechaFin').value,
          // },
          entidad,
          cliente_seleccion: rutClientes,
        };
        this.tipoDescuentoService.obtenerDescuentoProducto(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null && respuesta !== undefined;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            return false;
          }

          const { registros } = respuesta;
          let listaClientes = false;
          if (registros.length > 0) {
            listaClientes = true;
          } else {
            listaClientes = false;
          }

          const data = {
            registros,
            listaClientes,
            mensajes,
          };
          //SI RESPUESTA ES TRUE EL PRODUCTO SI EXISTE EN OTRO DESCUENTO
          //SI ES FALSE EL PRODUCTO NO SE ENCUENTRA EN OTRO DESCUENTO
          resolve(data);
        });
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  async validarExisteClienteEnDescuento(cliente_producto) {
    const a = await new Promise((resolve) => {
      setTimeout(() => {
        // const rutClientes = this.clientesSeleccionados.map((x) => x.rut);

        const inputParams = {
          entidad: {
            codigo: this.codigoDescuento,
            rut_empresa: this.rutEmpresa,
          },
          cliente_seleccion: cliente_producto.clientes_seleccionados,
          producto_seleccion: cliente_producto.lista_producto,
        };
        this.tipoDescuentoService.obtenerDescuentoCliente(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null && respuesta !== undefined;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            return false;
          }

          const { registros } = respuesta;
          let listaClientes = false;
          if (registros.length > 0) {
            listaClientes = true;
          } else {
            listaClientes = false;
          }

          const data = {
            registros,
            listaClientes,
          };
          //SI RESPUESTA ES TRUE EL PRODUCTO SI EXISTE EN OTRO DESCUENTO
          //SI ES FALSE EL PRODUCTO NO SE ENCUENTRA EN OTRO DESCUENTO
          resolve(data);
        });
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  validateExistenceInList({ sku }) {
    return this.listaDescuentos.filter((p) => p.sku === sku).length === 0;
  }

  createPayloadProducto(producto) {
    return {
      producto_codigo: producto.codigo,
      empresa_rut: producto.empresa_rut,
      sku: producto.sku,
      descripcion: producto.descripcion,
      tipoDescuento: this.formDetails.get('tipoDescuento').value,
      tipoDescuentoGlosa: this.optionsTipoDescuento.filter((opt) => Number(opt.value) === Number(this.formDetails.get('tipoDescuento').value))[0].label,
      monto: this.formDetails.get('tipoDescuento').value === '1' ? Number(this.formDetails.get('montoOrPorcentaje').value) : 0,
      porcentaje: this.formDetails.get('tipoDescuento').value === '2' ? Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.')) : 0,
      precio_unitario: producto.precio_unitario,
      precioFinal: this.calcularPrecioFinal(producto),
      descuento: this.calcularDescuento(producto.precio_unitario, Number(this.formDetails.get('montoOrPorcentaje').value), this.formDetails.get('tipoDescuento').value),
      index: this.listaDescuentos.length + 1,
    };
  }

  calcularPrecioFinal(producto) {
    let precioSinDescuento = producto.precio_unitario * 1; /*cantidad*/
    let precioFinal: number;

    if (producto.es_porcentaje == true) {
      precioFinal = precioSinDescuento - Math.round((precioSinDescuento * Number(producto.monto_descuento)) / 100);
      return precioFinal;
    } else if (producto.es_porcentaje == false) {
      const productMonto = producto.precio_fijo;
      precioFinal = precioSinDescuento - Number(productMonto);
      return precioFinal;
    }

    if (this.formDetails.get('tipoDescuento').value === '2') {
      // Descuento en porcentaje
      precioFinal = precioSinDescuento - Math.round((precioSinDescuento * Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.'))) / 100);
      return precioFinal;
    } else if (this.formDetails.get('tipoDescuento').value === '1') {
      // Descuento en monto
      precioFinal = precioSinDescuento - Number(this.formDetails.get('montoOrPorcentaje').value);
      return precioFinal;
    } else {
      throw new Error('Tipo de descuento no válido. Debe ser "porcentaje" o "monto".');
    }
  }

  calcularDescuento(precioUnitario: number, descuento: number, tipoDescuento: string): number {
    if (tipoDescuento === '2') {
      // Descuento en porcentaje
      descuento = Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.'));
      const descPorc = Math.round(precioUnitario * (descuento / 100));
      return descPorc;
    } else if (tipoDescuento === '1') {
      // Descuento en monto
      return descuento;
    } else {
      if (Boolean(tipoDescuento) == true) {
        descuento = Number(descuento);
        const descPorc = Math.round(precioUnitario * (descuento / 100));
        return descPorc;
      } else if (Boolean(tipoDescuento) == false) {
        return descuento;
      } else {
        throw new Error('Tipo de descuento no válido. Debe ser "porcentaje" o "monto".');
      }
    }
  }

  validateUnidadNegocioNewProduct({ unidad_negocio_codigo }): Boolean {
    if (!this.defaultUnidadNegocio) return true;
    return this.defaultUnidadNegocio === unidad_negocio_codigo;
  }

  fixAndDisableUnidadNegocio({ unidad_negocio_codigo }) {
    this.defaultUnidadNegocio = unidad_negocio_codigo; //this.formHeader.get("unidad_negocio_codigo").value
    // this.formHeader.get("unidad_negocio_codigo").setValue(unidad_negocio_codigo)
    // this.formHeader.get("unidad_negocio_codigo").disable()
  }

  renderItemDescuento() {
    // this.listaDescuentosPage = [...this.listaDescuentos]
    const from = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaDescuentosPage = this.listaDescuentos.slice(from, from + this.paginationContext.RecordsByPage);
    this.paginationContext.RecordsCount = this.listaDescuentos.length;
    this.paginationContext.PagesCount = Math.ceil(this.listaDescuentos.length / this.paginationContext.RecordsByPage);
  }

  eliminarItemDescuento(index) {
    this.listaDescuentos = this.listaDescuentos.filter((item) => item.index !== index);
    this.modalConfirm.show(() => {
      this.toastrService.warning('producto eliminado');
      this.renderItemDescuento();
    });
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return;
    }

    if (this.EditoDesc == 0) {
      this.toastrService.warning('Favor presionar Check del producto para confirmar modificación.');
      return;
    }

    const esTipoCliente = this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE;

    // if (this.formHeader.get("buscarPor").value === this.TIPO_CLIENTE) {
    if (esTipoCliente) {
      if (!this.tiposClientesSeleccionados || this.tiposClientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese tipos de clientes');
        return;
      }
    } else {
      if (!this.clientesSeleccionados || this.clientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese clientes');
        return;
      }
    }

    if (this.listaDescuentos.length == 0) {
      this.toastrService.warning('Favor corrija datos');
      return;
    }

    this.btnGuardarDisabled = true;

    let descuentoClienteProducto: any = {
      cabecera: {
        codigo: this.codigoDescuento,
        sucursal_codigo: Number(this.sucursalEmpresa),
        rut_empresa: Number(this.rutEmpresa),
        fecha_inicio: this.formHeader.get('fechaInicio').value,
        fecha_termino: this.formHeader.get('fechaFin').value,
        activado: this.formHeader.get('activo').value,
        esTipoCliente: false,
        descripcion: this.formHeader.get('descripcion').value,
        rut_usuario: this.rutUsuario,
        editarDescFecha: this.mode,
        moduloGrabacion: 6
      },
      detalleClientes: [],
      detalleProductos: [],
    };
    if (esTipoCliente) {
      descuentoClienteProducto.cabecera.esTipoCliente = true;
      descuentoClienteProducto.cabecera.tipo_cliente = this.tiposClientesSeleccionados.map((tipo) => ({ codigo: tipo.codigo }));
    } else {
      descuentoClienteProducto.detalleClientes = this.clientesSeleccionados.map((cliente) => ({
        cliente_proveedor_rut: cliente.rut,
        direccion_codigo: cliente.codigo_direccion,
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
      }));
    }
    descuentoClienteProducto.detalleProductos = this.listaDescuentos.map((producto) => ({
      sucursal_codigo: Number(this.sucursalEmpresa),
      rut_empresa: producto.empresa_rut,
      producto_codigo: producto.producto_codigo,
      skuProducto: producto.sku,
      es_porcentaje: producto.tipoDescuento === '2',
      monto_descuento: producto.tipoDescuento === '2' ? producto.porcentaje : 0,
      precio_fijo: producto.tipoDescuento === '2' ? 0 : producto.monto,
      descuento_cliente_codigo: this.codigoDescuento,
    }));

    const self = this;
    this.log('inputParams', JSON.stringify({ entidad: descuentoClienteProducto }));

    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoDTOInputType) {
            descuento {
              guardarDTO(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    sucursal_codigo
                    rut_empresa
                    codigo
                    descripcion
                    activado
                    fecha_inicio
                    fecha_termino
                  }
                  detalleClientes {
                    cliente_proveedor_rut
                    sucursal_codigo
                    rut_empresa
                    direccion_codigo
                    descuento_codigo
                  }
                  detalleProductos {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    descuento_cliente_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: descuentoClienteProducto,
        },
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.descuento.guardarDTO;

        //ERROR
        if (mensajes && mensajes.length > 0) {
          //Si existe un mensaje tipo error;

          const findError = mensajes.some((x) => x.tipo === 'ERROR');
          if (findError) {
            // self.messageRendererService.showErrors(mensajes, { positionClass: 'md-toast-top-center' })
            self.modalVerErrores.loadAndShow(mensajes);
            self.btnGuardarDisabled = false; // si existen al menos un error el btn no se desactiva.
            return;
          }

          //WARNING
          const findWarning = mensajes.some((x) => x.tipo === 'WARNING');
          if (findWarning) {
            // self.messageRendererService.showErrors(mensajes, { positionClass: 'md-toast-top-center' })
            self.modalVerErrores.loadAndShow(mensajes);
            self.btnGuardarDisabled = true; // si existen warning el btn se desactiva
            self.hide();
            self.onSuccess.emit();
            return;
          }
        } else {
          //SUCCESS
          self.toastrService.success('Descuento guardado');
          self.btnGuardarDisabled = true; // si estan todos los descuentos correctos el btn se desactiva
          self.hide();
          self.onSuccess.emit();
          return;
        }
        // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
        //   alert('Registro grabado');
        //   self.editarModalDtoComercielas.hide();
        // } else {
        //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
        // }
      }
    );
  }

  load(rut_empresa: number, sucursal_codigo: number, descuento_codigo: number, allowEdit: boolean = true) {
    this.currentTabs = "detalle";
    this.mode = allowEdit ? 'EDIT' : 'VIEW';
    this.codigoDescuento = descuento_codigo;
    const _variables = {
      rut_empresa,
      sucursal_codigo,
      descuento_codigo,
    };

    this.loaded = false;
    this.loading = true;

    this.log('_variables');
    this.log(JSON.stringify(_variables));

    // fecha_inicio
    // fecha_termino
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $descuento_codigo: Decimal) {
            descuento {
              obtenerSegunId(entidad: { codigo: $descuento_codigo, rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  fecha_inicio
                  fecha_termino
                  activado
                  descripcion
                }
              }
            }
            descuento_cliente {
              obtenerSegunFiltro(filtro: { exacto: { descuento_codigo: $descuento_codigo, rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    sucursal_codigo
                    rut_empresa
                    direccion_codigo
                    descuento_codigo
                    nombreCliente
                    direccionCliente
                  }
                }
              }
            }
            descuento_cliente_producto {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, descuento_cliente_codigo: $descuento_codigo, producto_codigo: -1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  totalPaginas
                  totalRegistros
                  registros {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    nombreProducto
                    descuento_cliente_codigo
                    skuProducto
                    precio_unitario
                  }
                }
              }
            }
          }
        `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // Descuento
        const { respuesta: descuento } = response.data.descuento.obtenerSegunId;
        self.formHeader.get('descripcion').setValue(descuento.descripcion);
        self.formHeader.get('activo').setValue(descuento.activado);
        self.formHeader.get('fechaInicio').setValue(descuento.fecha_inicio);
        self.formHeader.get('fechaFin').setValue(descuento.fecha_termino);

        // Header
        const { respuesta: respHeader } = response.data.descuento_cliente.obtenerSegunFiltro;
        const { registros: headerData } = respHeader;
        // self.formHeader.get('buscarPor').setValue(0)//: [this.TIPO_CLIENTE, [Validators.required]],
        // self.formHeader.get('clienteOrTipos').setValue(0)//: [null, [Validators.required]],
        self.clientesSeleccionados = headerData;

        self.clientesSeleccionados.forEach((cliente) => {
          cliente.nombre = cliente.nombreCliente;
          cliente.razon_social = cliente.nombreCliente;
          cliente.codigo_direccion = cliente.direccion_codigo;
          cliente.rut = cliente.cliente_proveedor_rut;
          cliente.direccion_completa = cliente.direccionCliente;
          cliente.guardado = true;
          cliente.checked = true;
        });

        self.clientesGuardadosAnterior = self.clientesSeleccionados;
        // self.clientesSeleccionadosFormatted = self.clientesSeleccionados.map(p => p.nombre).join(', ')
        self.modalSeleccionarCliente.setClientesSeleccionadosFromOutside(self.clientesSeleccionados);
        self.formHeader.get('clienteOrTipos').setValue(self.clientesSeleccionadosFormatted);

        const { mensajes, respuesta: respDetalles } = response.data.descuento_cliente_producto.obtenerSegunFiltro;
        const { registros: productsData, paginaActual, totalPaginas, totalRegistros } = respDetalles;

        // Products
        self.listaDescuentos = productsData.map((producto, index) => ({
          producto_codigo: producto.producto_codigo,
          empresa_rut: producto.rut_empresa,
          sku: producto.skuProducto,
          descripcion: producto.nombreProducto,
          tipoDescuento: producto.es_porcentaje ? '2' : '1',
          tipoDescuentoGlosa: self.optionsTipoDescuentoAll.filter((p) => p.value === (producto.es_porcentaje ? '2' : '1'))[0].label,
          monto: producto.es_porcentaje ? 0 : producto.precio_fijo,
          porcentaje: producto.es_porcentaje ? producto.monto_descuento : 0,
          precio_unitario: producto.precio_unitario,
          precioFinal: self.calcularPrecioFinal(producto),
          descuento: self.calcularDescuento(producto.precio_unitario, producto.es_porcentaje ? producto.monto_descuento : producto.precio_fijo, producto.es_porcentaje),
          index,
        }));

        self.paginationContext.CurrentPage = 1;
        self.renderItemDescuento();

        self.show(self.mode);
      }
    );
  }
  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados);
  }

  uncheckProducto(producto) {
    this.productosMultiplesSeleccionados = this.productosMultiplesSeleccionados.filter((p) => p.sku !== producto.sku);
    if (this.productosMultiplesSeleccionados.length === 0) this.productosMultiplesSeleccionados = null;
  }
}
